import { ICardInformation } from '../../interfaces';

const getCardExpiration = (cardInformation: ICardInformation): string =>
  cardInformation &&
  `${cardInformation.month}/${
    cardInformation.year && cardInformation.year.toString().substring(2)
  }`;

export default getCardExpiration;
